import React, { SVGProps } from 'react';

export const CaptionOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.4 6.3v1.8h-12V6.3zM14.4 12.3h-9v-1.8h9zM5.4 16.5h6v-1.8h-6z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.4 0c8.641 0 11.4 2.759 11.4 11.4s-2.759 11.4-11.4 11.4S0 20.041 0 11.4 2.759 0 11.4 0m0 1.8c4.239 0 6.438.703 7.668 1.932S21 7.162 21 11.4c0 4.239-.703 6.438-1.932 7.668S15.638 21 11.4 21c-4.239 0-6.438-.703-7.668-1.932S1.8 15.638 1.8 11.4c0-4.239.703-6.438 1.932-7.668S7.162 1.8 11.4 1.8"
      clipRule="evenodd"
    />
  </svg>
);
